import { gql } from "@apollo/client";

const schema = {
  current: {
    name: "lab",
    serviceName: "graphql",
    query: gql`
      query lab($ids: [String]) {
        lab(ids: $ids) {
          data {
            media {
              id
              name
              full_url
              size
              collection_name
            }
          }
        }
      }
    `,
  },
};

export default schema;
